import { get } from 'lodash';

import APIClient from '../../services/APIClient';
import { clearRulesIds, fillRulesWithIds } from './QueryBuilder/utils';

export const setAdvancedSearchPresets = (presets) => ({
  type: 'SET_ADVANCED_SEARCH_PRESETS',
  presets,
});

export const setUpdatedAdvancedSearchPreset = (preset) => ({
  type: 'SET_UPDATED_ADVANCED_SEARCH_PRESET',
  preset,
});

export const setSelectedProductTypes = (types) => ({
  type: 'SET_SELECTED_PRODUCT_TYPES',
  types,
});

export const addAdvancedSearchPreset = (preset) => ({
  type: 'ADD_ADVANCED_SEARCH_PRESET',
  preset,
});

export const removeAdvancedSearchPreset = (id) => ({
  type: 'REMOVE_ADVANCED_SEARCH_PRESET',
  id,
});

export const setSelectedTabAdvancedSearch = (selectedTab, id) => ({
  type: 'SET_SELECTED_TAB_ADVANCED_SEARCH',
  selectedTab,
  id,
});

export const setActiveAdvancedSearchPreset = (id) => ({
  type: 'SET_ACTIVE_ADVANCED_SEARCH_PRESET',
  id,
});

export const setAdvancedSearchSuggestions = (field, suggestions) => ({
  type: 'SET_ADVANCED_SEARCH_SUGGESTIONS',
  field,
  suggestions,
});

export const removeAdvancedSearchSuggestions = (field) => ({
  type: 'REMOVE_ADVANCED_SEARCH_SUGGESTIONS',
  field,
});

export const loadAdvancedSearchPresets = (pageId) => (dispatch) => {
  APIClient.get('/chargers/searchies', { params: { page_size: 999, page_id: pageId } })
    .then(({ data }) => {
      const presets = data.map((item) => {
        const preset = {
          ...item,
          query: JSON.parse(item.query) || { rules: [] },
        };

        preset.query.id = preset.uuid;
        fillRulesWithIds(preset.query.rules);

        return preset;
      });

      dispatch(setAdvancedSearchPresets(presets));
    })
    .catch((error) => {
      console.error(error);
    });
};

export const createAdvancedSearchPreset =
  ({ name, description, query }, pageId) =>
  (dispatch) => {
    if (typeof query === 'string') {
      try {
        query = JSON.parse(query);
      } catch (e) {
        console.error('Invalid query JSON:', e);

        return;
      }
    }

    delete query.id;
    clearRulesIds(query.rules);

    APIClient.post('/chargers/searchies', {
      name,
      description,
      query,
      pageId,
    })
      .then(({ data }) => {
        if (typeof data.query === 'string') {
          data.query = JSON.parse(data.query);
        }

        data.query.id = data.uuid;
        fillRulesWithIds(data.query.rules);
        dispatch(addAdvancedSearchPreset(data));
      })
      .catch((error) => {
        console.error(error);
      });
  };

export const updateAdvancedSearchPreset =
  ({ uuid, name, description, query }, pageId) =>
  (dispatch) => {
    delete query.id;
    clearRulesIds(query.rules);

    APIClient.put(`/chargers/searchies/${uuid}`, {
      uuid,
      name,
      description,
      query,
      pageId,
    })
      .then(({ data }) => {
        if (typeof data.query === 'string') {
          data.query = JSON.parse(data.query);
        }

        dispatch(setUpdatedAdvancedSearchPreset(data));
      })
      .catch((error) => console.error(error));
  };

export const deleteAdvancedSearchPreset = (id) => (dispatch) => {
  APIClient.delete(`/chargers/searchies/${id}`)
    .then(() => {
      dispatch(removeAdvancedSearchPreset(id));
    })
    .catch((error) => {
      console.error(error);
    });
};

export const fetchAdvancedSearchSuggestions = (field, value) => (dispatch) => {
  if (field === 'plaza_uuid') {
    APIClient.get('/plazas', { params: { page_token: 0, page_size: 999 } }).then((response) => {
      const suggestions = get(response, 'data.payloads', []).map((item) => ({ label: item.name }));

      dispatch(setAdvancedSearchSuggestions(field, suggestions));
    });
  }
};
